import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLogOut } = FiIcons;

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50 backdrop-blur-sm bg-white/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              {/* Hide "by Angry Branding" on mobile, show on desktop */}
              <span className="hidden sm:block text-xs text-gray-600 font-light mr-2">by Angry Branding</span>
              <span className="text-xl font-semibold text-black tracking-tight">Snap</span>
            </Link>
            <span className="ml-3 px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
              Beta
            </span>
          </div>

          <div className="flex items-center space-x-4 sm:space-x-8">
            {user ? (
              <>
                <Link
                  to="/dashboard"
                  className="text-gray-600 hover:text-black font-medium transition-colors text-sm sm:text-base"
                >
                  Dashboard
                </Link>
                <Link
                  to="/create-album"
                  className="bg-black text-white px-4 sm:px-6 py-2 rounded-md hover:bg-gray-800 font-medium transition-all btn-primary text-sm sm:text-base"
                >
                  Create Album
                </Link>

                <div className="hidden sm:flex items-center space-x-4 border-l border-gray-200 pl-4">
                  <span className="text-gray-700 text-sm">{user.name}</span>
                  <button
                    onClick={handleLogout}
                    className="text-gray-500 hover:text-gray-700 transition-colors p-1"
                    title="Logout"
                  >
                    <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                  </button>
                </div>

                {/* Mobile user menu */}
                <div className="sm:hidden">
                  <button
                    onClick={handleLogout}
                    className="text-gray-500 hover:text-gray-700 transition-colors p-1"
                    title="Logout"
                  >
                    <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                  </button>
                </div>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-gray-600 hover:text-black font-medium transition-colors text-sm sm:text-base"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="bg-black text-white px-4 sm:px-6 py-2 rounded-md hover:bg-gray-800 font-medium transition-all btn-primary text-sm sm:text-base"
                >
                  {/* Remove "Free" on mobile, show full text on desktop */}
                  <span className="sm:hidden">Sign Up</span>
                  <span className="hidden sm:inline">Sign Up Free</span>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;